<script lang="ts">
	import AccordionItem from '$lib/components/AccordionItem.svelte';

	const accordionData = [
		//{
		//	title: 'What photos or information are shared with third parties?',
		//	description:
		//		"We created this app to use with our family members, so privacy is paramount to us. This means we host our own AI infrastructure on standard cloud providers, and keep your photos within our walls. We use open source technology and models, rather than OpenAI (or any other comparable 3rd parties). We don't share your data.",
		//},
		{
			title: 'What photos or information are shared with third parties?',
			description:
				"We created this app to use with our family members, so privacy is paramount to us. We use open source technology and models, rather than OpenAI (or any other comparable 3rd parties). We don't share or sell your data.",
		},
		{
			title: 'Are photos used to train models that are accessible to anyone else?',
			description:
				'Your photos are solely used to create personalized stories for you and you alone. We do not use your photos to train models that are accessible to anyone else.',
		},
		{
			title: 'How can I delete a character, story, or my account?',
			description:
				'You can delete a specific character from the <a class="link" href="/character">characters page</a>. When you remove a character, all photos & associated with that character will be deleted as well. You can delete a story from your <a class="link" href="/design">stories page</a>. Removing a story removes all images & text associated with that story. You can delete your account from <a class="link" href="/settings/profile">your account settings page</a>. This will fully wipe all data associated with your account from our systems.',
		},
		{
			title: 'What is "generative AI" and how is it used in the app?',
			description:
				'From <a class="link" href="https://en.wikipedia.org/wiki/Generative_artificial_intelligence">Wikipedia</a>, generative artificial intelligence (generative AI, GenAI or GAI) is artificial intelligence capable of generating text, images, videos, or other data using generative models, often in response to prompts. We use it as a tool to help our authors illustrate their stories. The same technology is used to insert the likeness of your loved ones into our stories\' illustrations in a consistent style. It\'s how we can create personalized kids books for any child.',
		},
		{
			title: "What if I don't like a photo in a personalized story? How do I fix this?",
			description:
				'Our technology isn\'t always perfect. Each personalized page has an "edit" button that allows you to generate alternative images for that page. This will replace the existing photo with the new one.',
		},
		{
			title: 'Are stories or non-personalized images also AI generated?',
			description:
				"Our stories are written by humans. We believe technology is an innovation amplifier. The point of our tools is to push the boundaries of our creativity as storytellers. AI helps our creators refine & illustrate their stories; it enables our illustrators share their styles; and lets families illustrate their loved ones in books. Non-personalized images are hand-selected by the author, and may be created using any of the author's preferred tools.",
		},
		{
			title: 'Do credits expire or rollover?',
			description:
				'Credits expire at the end of each month. Unused credits do not rollover to the next month if you do not use them all.',
		},
		{
			title: 'How do I cancel my subscription?',
			description:
				'You can cancel your subscription at any time from your <a class="link" href="/settings/profile">billing settings page</a>. Your subscription will remain active until the end of the current billing period.',
		},
		{
			title: 'How do I contact support?',
			description:
				'You can contact support by emailing <a class="link" href="mailto:hello@trystorytime.com">hello@trystorytime.com</a>.',
		},
	];
</script>

{#each accordionData as { title, description }}
	<AccordionItem {title} {description} />
{/each}
